import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import CollectionsView from '@/views/CollectionsView.vue'
import CollectionView from '@/views/CollectionView.vue'
import CallView from '@/views/CallView.vue'
import TaskRankExpView from '@/views/TaskRankExpView.vue'
import TaskFreeWritingView from '@/views/TaskFreeWritingView.vue'
import TaskReviewTranscriptView from '@/views/TaskReviewTranscriptView.vue'
import TasksView from '@/views/TasksView.vue'
import VideosView from '@/views/VideosView.vue'
import VideoView from '@/views/VideoView.vue'
import CallsView from '@/views/CallsView.vue'
import CallTranscriptView from '@/views/CallTranscriptView.vue'
import ChatsView from '@/views/ChatsView.vue'
import StatsView from '@/views/StatsView.vue'
import StudentsView from '@/views/StudentsView.vue'
import TaskFreeSpeakingView from '@/views/TaskFreeSpeakingView.vue'
import TemplatesView from '@/views/TemplatesView.vue'
import ProfileView from '@/views/ProfileView.vue'
import TaskView from '@/views/TaskView.vue'
import StudentsApiView from '@/views/StudentsApiView.vue'
import CurationView from '@/views/CurationView.vue'
import UsersView from '@/views/UsersView.vue'
import store from '@/store'

Vue.use(VueRouter)

const baseUrl = '/' // process.env.NODE_ENV === 'production' ? '/greenvalley/' : '/'

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Root',
    component: HomeView,
    meta: {
      breadCrumb: [
        {
          text: 'Home',
          to: baseUrl
        }
      ]
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeView,
    meta: {
      breadCrumb: [
        {
          text: 'Home',
          to: baseUrl + 'home'
        }
      ]
    }
  },
  {
    path: '/stats',
    name: 'Stats',
    component: StatsView,
    meta: {
      breadCrumb: [
        {
          text: 'Stats',
          to: baseUrl + 'stats'
        }
      ]
    }
  },
  {
    path: '/students',
    name: 'Students',
    component: StudentsView,
    meta: {
      breadCrumb: [
        {
          text: 'Students',
          to: baseUrl + 'students'
        }
      ]
    }
  },
  {
    path: '/home/studentsApi',
    name: 'StudentsApi',
    component: StudentsApiView,
    meta: {
      breadCrumb: [
        {
          text: 'StudentsApi',
          to: baseUrl + 'studentsApi'
        }
      ]
    }
  },
  {
    path: '/home/users',
    name: 'Users',
    component: UsersView,
    meta: {
      breadCrumb: [
        {
          text: 'Users',
          to: baseUrl + 'users'
        }
      ]
    }
  },
  {
    path: '/home/collections',
    name: 'Collections',
    component: CollectionsView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Collections',
            to: baseUrl + 'home/collections'
          }
        ]
      }
    }
  },
  {
    path: '/home/collection',
    name: 'Collection',
    component: CollectionView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Collection',
            to: baseUrl + 'home/collection'
          }
        ]
      }
    }
  },
  {
    path: '/home/rankExpressions',
    name: 'TaskRankExpView',
    component: TaskRankExpView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Rank Expressions',
            to: baseUrl + 'home/rankExpressions'
          }
        ]
      }
    }
  },
  {
    path: '/home/freeWriting',
    name: 'NewTaskFreeWritingView',
    component: TaskFreeWritingView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Free Writing',
            to: baseUrl + 'home/freeWriting'
          }
        ]
      }
    }
  },
  {
    path: '/home/freeWriting/:taskId',
    name: 'TaskFreeWritingView',
    component: TaskFreeWritingView,
    meta: {
      breadCrumb (route: Route) {
        const taskId = route.params.taskId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Free Writing',
            to: baseUrl + 'home/freeWriting'
          },
          {
            text: `${taskId}`,
            to: baseUrl + 'home/freeWriting/' + taskId
          }
        ]
      }
    }
  },
  {
    path: '/home/freeSpeaking',
    name: 'NewTaskFreeSpeakingView',
    component: TaskFreeSpeakingView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Free Speaking',
            to: baseUrl + 'home/freeSpeaking'
          }
        ]
      }
    }
  },
  {
    path: '/home/freeSpeaking/:taskId',
    name: 'TaskFreeSpeakingView',
    component: TaskFreeSpeakingView,
    meta: {
      breadCrumb (route: Route) {
        const taskId = route.params.taskId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Free Speaking',
            to: baseUrl + 'home/freeSpeaking'
          },
          {
            text: `${taskId}`,
            to: baseUrl + 'home/freeSpeaking/' + taskId
          }
        ]
      }
    }
  },
  {
    path: '/home/reviewTranscript/:taskId',
    name: 'TaskReviewTranscriptView',
    component: TaskReviewTranscriptView,
    meta: {
      breadCrumb (route: Route) {
        const taskId = route.params.taskId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Review Transcript',
            to: baseUrl + 'home/reviewTranscript'
          },
          {
            text: `${taskId}`,
            to: baseUrl + 'home/reviewTranscript/' + taskId
          }
        ]
      }
    }
  },
  {
    path: '/home/curation',
    name: 'Curation',
    component: CurationView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Curation',
            to: baseUrl + 'home/Curation'
          }
        ]
      }
    }
  },
  {
    path: '/home/tasks',
    name: 'Tasks',
    component: TasksView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Tasks',
            to: baseUrl + 'home/tasks'
          }
        ]
      }
    }
  },
  {
    path: '/home/calls',
    name: 'Calls',
    component: CallsView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Calls',
            to: baseUrl + 'home/calls'
          }
        ]
      }
    }
  },
  {
    path: '/home/chats',
    name: 'Chats',
    component: ChatsView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Chats',
            to: baseUrl + 'home/chats'
          }
        ]
      }
    }
  },
  {
    path: '/home/videos',
    name: 'Videos',
    component: VideosView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Videos',
            to: baseUrl + 'home/videos'
          }
        ]
      }
    }
  },
  {
    path: '/home/video/:videoId',
    name: 'PlayerVideo',
    component: VideoView,
    meta: {
      breadCrumb (route: Route) {
        const videoId = route.params.videoId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Video',
            to: baseUrl + 'home/video'
          },
          {
            text: 'VideoPlayer',
            to: baseUrl + 'home/video/' + videoId
          }
        ]
      }
    }
  },
  {
    path: '/home/collection/:collectionId',
    name: 'PlayerCollection',
    component: CollectionView,
    meta: {
      breadCrumb (route: Route) {
        const collectionId = route.params.collectionId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Collection',
            to: baseUrl + 'home/collection'
          },
          {
            text: 'CollectionPlayer',
            to: baseUrl + 'home/collection/' + collectionId
          }
        ]
      }
    }
  },
  {
    path: '/home/call/:callId',
    name: 'Call',
    component: CallView,
    meta: {
      breadCrumb (route: Route) {
        const callId = route.params.callId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Call',
            to: baseUrl + 'home/call/' + callId
          }
        ]
      }
    }
  },
  {
    path: '/home/callTranscript/:callId',
    name: 'Call Transcript',
    component: CallTranscriptView,
    meta: {
      breadCrumb (route: Route) {
        const callId = route.params.callId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Call Transcript',
            to: baseUrl + 'home/callTranscript/' + callId
          }
        ]
      }
    }
  },
  {
    path: '/home/templates',
    name: 'Templates',
    component: TemplatesView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Templates',
            to: baseUrl + 'home/templates'
          }
        ]
      }
    }
  },
  {
    path: '/home/profile',
    name: 'Profile',
    component: ProfileView,
    meta: {
      breadCrumb (route: Route) {
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Profile',
            to: baseUrl + 'home/profile'
          }
        ]
      }
    }
  },
  {
    path: '/home/task/:taskId',
    name: 'Task',
    component: TaskView,
    meta: {
      breadCrumb (route: Route) {
        const taskId = route.params.taskId
        return [
          {
            text: 'Home',
            to: baseUrl + 'home'
          },
          {
            text: 'Task',
            to: baseUrl + 'home/task'
          },
          {
            text: `${taskId}`,
            to: baseUrl + 'home/task/' + taskId
          }
        ]
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: baseUrl,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.loggedIn && to.name !== 'Home') {
    next('Home')
  } else {
    next()
  }
})

export default router
